<template>
  <div>
    <div class="page-header header-filter header-tiny bg-tri-1">
      <b-container>
        <b-row align-h="center">
        <h1>Worlds</h1>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <input type="text" v-model="title" placeholder="Title">
          </b-col>
          <b-col>
            <b-button v-on:click="createWorld({ title })">Create World</b-button>
          </b-col>
        </b-row>
        <b-row v-for="item in worlds" :key="item.id">
          <b-col>
            <h3>{{ item.title }}</h3>
            <ul>
              <li v-for="(value,prop) in item" :key="prop">{{prop}}: {{value}}</li>
            </ul>
            <hr/>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState,mapActions } = createNamespacedHelpers('admin/worlds')

export default {
  name: 'Worlds',
  async created() {
    this.loadWorlds();
  },
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapState(['worlds'])
  },
  methods: {
    ...mapActions(['createWorld','loadWorlds'])
  }
}
</script>

<style>

</style>